import React, { useState } from 'react';
import {
  MdArrowBack, MdSearch, MdChat, MdPhoneInTalk, MdLocationOn,
  MdCreditCard, MdReceiptLong, MdLockOutline, MdSwapHoriz, MdShield,
  MdAccountBalanceWallet, MdHelpOutline, MdExpandMore, MdChevronRight,
} from 'react-icons/md';

const TOPICS = [
  { id: 'cards',     Icon: MdCreditCard,           label: 'Cards & limits',     tint: 'var(--td-brown)'  },
  { id: 'transfers', Icon: MdSwapHoriz,            label: 'Transfers & e-Transfer', tint: 'var(--td-green)' },
  { id: 'bills',     Icon: MdReceiptLong,          label: 'Bills & payees',     tint: 'var(--td-amber)'  },
  { id: 'security',  Icon: MdShield,               label: 'Security & fraud',   tint: 'var(--td-red)'    },
  { id: 'pwd',       Icon: MdLockOutline,          label: 'Sign-in & password', tint: 'var(--td-premium)'},
  { id: 'accts',     Icon: MdAccountBalanceWallet, label: 'Accounts & statements', tint: 'var(--td-blue)'},
];

const FAQS = [
  {
    q: 'Why was my e-Transfer declined?',
    a: 'Decline can happen if the recipient\'s email or security answer is wrong, the daily transfer limit has been hit, or the receiving bank rejected the deposit. Open the transfer in your activity to see the exact reason.',
  },
  {
    q: 'How do I lock or replace my card?',
    a: 'Tap the card under "My Accounts" and use the Lock toggle to freeze it instantly. Replace lets you order a new physical card — the old one stops working as soon as the new one is activated.',
  },
  {
    q: 'I see a charge I don\'t recognize.',
    a: 'Open the transaction and tap "I don\'t recognize this." We\'ll start a dispute and freeze the card if needed. Most disputes resolve in 5-10 business days.',
  },
  {
    q: 'Can I use TD outside Canada?',
    a: 'Yes. Set a travel notice on the card before you leave so foreign transactions don\'t trip fraud rules. Tap the card → Travel Notice.',
  },
  {
    q: 'How do I download my tax slips?',
    a: 'Open Statements & Documents from the menu. Tax slips appear in late February for the previous year and are available for the last 7 years.',
  },
];

const HelpScreen = ({ onNavigate, onBack }) => {
  const [query, setQuery] = useState('');
  const [openId, setOpenId] = useState(null);

  const filtered = FAQS.filter(f =>
    !query.trim() ||
    f.q.toLowerCase().includes(query.toLowerCase()) ||
    f.a.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Help & Support</h1>
        </div>
        <MdHelpOutline size={22} style={{ color: 'var(--bh-black)' }} />
      </header>

      <div className="bh-flow-body">
        <div className="bh-form-card" style={{ gap: 'var(--space-2xs)' }}>
          <span style={{ font: 'var(--bh-overline)', textTransform: 'uppercase', color: 'var(--bh-gray)' }}>
            How can we help?
          </span>
          <div style={{ position: 'relative' }}>
            <MdSearch size={18} style={{
              position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
              color: 'var(--bh-gray)', pointerEvents: 'none',
            }} />
            <input
              className="bh-field-input"
              type="search"
              placeholder="Search help topics"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={{ paddingLeft: 36 }}
            />
          </div>
        </div>

        <button
          type="button"
          onClick={() => onNavigate('chat')}
          style={{
            display: 'flex', alignItems: 'center', gap: 'var(--space-sm)',
            width: '100%', padding: 'var(--space-md)',
            background: 'var(--td-premium)', color: 'var(--bh-white)',
            border: 'none', cursor: 'pointer',
            borderRadius: 'var(--radius-md)',
            textAlign: 'left',
          }}
        >
          <span style={{
            width: 42, height: 42, background: 'rgba(255,255,255,0.16)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0, borderRadius: 'var(--radius-md)',
          }}>
            <MdChat size={22} />
          </span>
          <div style={{ flex: 1 }}>
            <div style={{ font: 'var(--bh-body)', fontWeight: 700 }}>Ask IVA</div>
            <div style={{ font: 'var(--bh-caption)', opacity: 0.8 }}>
              Your virtual assistant — always available
            </div>
          </div>
          <MdChevronRight size={22} />
        </button>

        <section>
          <h2 className="bh-section-title" style={{ paddingLeft: 0 }}>Browse topics</h2>
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 'var(--space-sm)',
          }}>
            {TOPICS.map(t => {
              const Icon = t.Icon;
              return (
                <button
                  key={t.id}
                  type="button"
                  className="bh-qa-card"
                  onClick={() => onNavigate('chat')}
                >
                  <div className="bh-qa-icon" style={{ background: t.tint }}>
                    <Icon size={20} />
                  </div>
                  <span>{t.label}</span>
                </button>
              );
            })}
          </div>
        </section>

        <section>
          <h2 className="bh-section-title" style={{ paddingLeft: 0 }}>
            {query.trim() ? `${filtered.length} result${filtered.length === 1 ? '' : 's'}` : 'Frequently asked'}
          </h2>
          <div className="bh-form-card" style={{ padding: 0, gap: 0 }}>
            {filtered.map((f, i) => {
              const isOpen = openId === f.q;
              return (
                <div
                  key={f.q}
                  style={{
                    borderBottom: i === filtered.length - 1 ? 'none' : '1px solid var(--bh-light-gray)',
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : f.q)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 'var(--space-sm)',
                      width: '100%', padding: 'var(--space-sm)',
                      background: 'transparent', border: 'none', cursor: 'pointer',
                      textAlign: 'left',
                    }}
                    aria-expanded={isOpen}
                  >
                    <span style={{ flex: 1, font: 'var(--bh-body)', fontWeight: 600, color: 'var(--bh-black)' }}>
                      {f.q}
                    </span>
                    <MdExpandMore
                      size={20}
                      style={{
                        color: 'var(--bh-gray)',
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
                        transition: 'transform 0.15s ease',
                      }}
                    />
                  </button>
                  {isOpen && (
                    <div style={{
                      padding: '0 var(--space-sm) var(--space-sm)',
                      font: 'var(--bh-body-sm)', color: 'var(--bh-dark)', lineHeight: 1.5,
                    }}>
                      {f.a}
                    </div>
                  )}
                </div>
              );
            })}
            {filtered.length === 0 && (
              <div style={{ padding: 'var(--space-md)', font: 'var(--bh-body-sm)', color: 'var(--bh-gray)', textAlign: 'center' }}>
                No matches. Try a different word, or ask IVA above.
              </div>
            )}
          </div>
        </section>

        <section>
          <h2 className="bh-section-title" style={{ paddingLeft: 0 }}>Still need help?</h2>
          <div className="bh-action-row">
            <button className="bh-action-card" onClick={() => onNavigate('call')}>
              <div className="bh-action-card-icon" style={{ background: 'var(--td-blue)', color: 'var(--bh-white)' }}>
                <MdPhoneInTalk size={20} />
              </div>
              <span>Call us</span>
            </button>
            <button className="bh-action-card" onClick={() => onNavigate('locations')}>
              <div className="bh-action-card-icon" style={{ background: 'var(--td-red)', color: 'var(--bh-white)' }}>
                <MdLocationOn size={20} />
              </div>
              <span>Find a branch</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HelpScreen;
